// canvas-setup.js - Canvas initialization and configuration module

(function(window) {
  'use strict';

  // ===== CANVAS CONFIGURATION CONSTANTS =====
  const CANVAS_DISPLAY_SIZE = 700;  // CSS display size
  const CANVAS_INTERNAL_SIZE = 1400; // 2x resolution for crisp rendering
  const RESOLUTION_SCALE = 2;

  // ===== CANVAS ELEMENTS SETUP =====
  const CanvasSetup = {
    // Store canvas references
    canvases: {},
    contexts: {},
    
    // Initialize background canvas
    initBackgroundCanvas: function() {
      const cvs_bg = document.getElementById("cvs_bg");
      if (!cvs_bg) return null;
      
      cvs_bg.width = CANVAS_INTERNAL_SIZE;
      cvs_bg.height = CANVAS_INTERNAL_SIZE;
      cvs_bg.style.width = CANVAS_DISPLAY_SIZE + 'px';
      cvs_bg.style.height = CANVAS_DISPLAY_SIZE + 'px';
      
      const ctx_bg = cvs_bg.getContext("2d");
      ctx_bg.scale(RESOLUTION_SCALE, RESOLUTION_SCALE);
      
      this.canvases.bg = cvs_bg;
      this.contexts.bg = ctx_bg;
      
      return {
        canvas: cvs_bg,
        context: ctx_bg,
        width: CANVAS_DISPLAY_SIZE,
        height: CANVAS_DISPLAY_SIZE
      };
    },
    
    // Initialize t-shirt canvas
    initTshirtCanvas: function() {
      const cvs_ts = document.getElementById("cvs_ts");
      if (!cvs_ts) return null;
      
      cvs_ts.width = CANVAS_INTERNAL_SIZE;
      cvs_ts.height = CANVAS_INTERNAL_SIZE;
      cvs_ts.style.width = CANVAS_DISPLAY_SIZE + 'px';
      cvs_ts.style.height = CANVAS_DISPLAY_SIZE + 'px';
      
      const ctx_ts = cvs_ts.getContext("2d");
      ctx_ts.scale(RESOLUTION_SCALE, RESOLUTION_SCALE);
      
      this.canvases.ts = cvs_ts;
      this.contexts.ts = ctx_ts;
      
      return {
        canvas: cvs_ts,
        context: ctx_ts,
        width: CANVAS_DISPLAY_SIZE,
        height: CANVAS_DISPLAY_SIZE
      };
    },
    
    // Initialize transparency canvas
    initTransparencyCanvas: function() {
      const cvs_trans = document.getElementById("cvs_trans");
      if (!cvs_trans) return null;
      
      cvs_trans.width = CANVAS_INTERNAL_SIZE;
      cvs_trans.height = CANVAS_INTERNAL_SIZE;
      cvs_trans.style.width = CANVAS_DISPLAY_SIZE + 'px';
      cvs_trans.style.height = CANVAS_DISPLAY_SIZE + 'px';
      
      const ctx_trans = cvs_trans.getContext("2d");
      ctx_trans.scale(RESOLUTION_SCALE, RESOLUTION_SCALE);
      
      this.canvases.trans = cvs_trans;
      this.contexts.trans = ctx_trans;
      
      return {
        canvas: cvs_trans,
        context: ctx_trans,
        width: CANVAS_DISPLAY_SIZE,
        height: CANVAS_DISPLAY_SIZE
      };
    },
    
    // Initialize text canvas (for Team Wall and other text)
    initTextCanvas: function() {
      const cvs_txt = document.getElementById("cvs_txt_temp");
      if (!cvs_txt) return null;
      
      // Text canvas doesn't set internal size here - it's set dynamically
      cvs_txt.style.width = CANVAS_DISPLAY_SIZE + 'px';
      cvs_txt.style.height = CANVAS_DISPLAY_SIZE + 'px';
      
      this.canvases.txt = cvs_txt;
      
      return {
        canvas: cvs_txt,
        width: CANVAS_DISPLAY_SIZE,
        height: CANVAS_DISPLAY_SIZE
      };
    },
    
    // Initialize designs canvas (main interactive canvas)
    initDesignsCanvas: function() {
      const cvs = document.getElementById("cvs_designs");
      if (!cvs) return null;
      
      cvs.width = CANVAS_INTERNAL_SIZE;
      cvs.height = CANVAS_INTERNAL_SIZE;
      cvs.style.width = CANVAS_DISPLAY_SIZE + 'px';
      cvs.style.height = CANVAS_DISPLAY_SIZE + 'px';
      
      const ctx = cvs.getContext("2d");
      ctx.scale(RESOLUTION_SCALE, RESOLUTION_SCALE);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      this.canvases.designs = cvs;
      this.contexts.designs = ctx;
      
      return {
        canvas: cvs,
        context: ctx,
        width: CANVAS_DISPLAY_SIZE,
        height: CANVAS_DISPLAY_SIZE
      };
    },
    
    // Initialize all canvases
    initAll: function() {
      return {
        background: this.initBackgroundCanvas(),
        tshirt: this.initTshirtCanvas(),
        transparency: this.initTransparencyCanvas(),
        text: this.initTextCanvas(),
        designs: this.initDesignsCanvas(),
        displaySize: CANVAS_DISPLAY_SIZE,
        internalSize: CANVAS_INTERNAL_SIZE,
        scale: RESOLUTION_SCALE
      };
    }
  };

  // ===== SHARED DRAW UTILITIES =====
  function drawCentered(ctx, img, canvasW, canvasH) {
    var imgW = img.naturalWidth || img.width;
    var imgH = img.naturalHeight || img.height;
    var cH = canvasH || canvasW; // allow square shorthand
    var scale = Math.min(canvasW / imgW, cH / imgH);
    var drawW = imgW * scale;
    var drawH = imgH * scale;
    var drawX = (canvasW - drawW) / 2;
    var drawY = (cH - drawH) / 2;
    ctx.drawImage(img, drawX, drawY, drawW, drawH);
  }

  // ===== EXPORTED API =====
  window.CanvasModule = {
    // Constants
    CANVAS_DISPLAY_SIZE: CANVAS_DISPLAY_SIZE,
    CANVAS_INTERNAL_SIZE: CANVAS_INTERNAL_SIZE,
    RESOLUTION_SCALE: RESOLUTION_SCALE,

    // Canvas setup
    setup: CanvasSetup,

    // Zoom management — delegates to DesignAreas (single source of truth)
    zoom: {
      resetZoom: function() {
        if (window.DesignAreas) {
          window.DesignAreas.applyCanvasZoom({ scale: 1, translateX: 0, translateY: 0 }, false);
          window.DesignAreas.setCurrentZoom(null);
        }
      }
    },

    // Convenience methods
    initializeCanvases: function() {
      return CanvasSetup.initAll();
    },

    getCanvas: function(name) {
      return CanvasSetup.canvases[name];
    },

    getContext: function(name) {
      return CanvasSetup.contexts[name];
    },

    // Shared draw utility
    drawCentered: drawCentered
  };

})(window);